import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Icon } from 'antd';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { paths } from '../../constants/paths';
import { filterNames } from '../../constants/filterNames';
import styles from './ButtonToDashboard.module.scss';

const ButtonToDashboard = () => {
  const mainSearchParams = useSelector(
    (state) => state.statisticsStore.mainSearchParams
  );

  const history = useHistory();

  const handleClick = () => {
    let search = '';

    if (!mainSearchParams) {
      const searchParams = new URLSearchParams(history.location.search);

      Array.from(searchParams.keys()).forEach((key) => {
        if (
          key === filterNames.statusChangePeriod ||
          key === filterNames.expiredPeriod
        ) {
          searchParams.delete(key);
        }
      });

      search = searchParams.toString();
    } else {
      search = mainSearchParams;
    }

    history.push({
      pathname: `${paths.newRoot}`,
      search,
    });
  };

  return (
    <RoundedButton
      className={styles.root}
      type="secondary"
      text="Вернуться на начальный экран"
      invert
      iconLeft={<Icon type="left" />}
      onClick={handleClick}
    />
  );
};

export default ButtonToDashboard;
